import { computed, defineComponent, inject, toRefs } from "vue";
import { useFormItemCheck } from "../hook";
import { FormInjectionKey } from "../const";
import "./checkbox.less";
export default defineComponent({
  name: "CCheckbox",
  props: {
    modelValue: Boolean,
    readonly: Boolean,
  },
  setup(props, { emit, slots }) {
    const { modelValue, readonly } = toRefs(props);
    const notifyCheck = useFormItemCheck();
    const form = inject(FormInjectionKey, undefined);
    const handleInput = (e: Event) => {
      const checkbox = e.target as HTMLInputElement;
      emit("update:modelValue", checkbox.checked);
      notifyCheck(true);
    };
    const checkboxClass = computed(() => {
      let res = "c-checkbox";
      if (modelValue.value) {
        res += " c-checkbox-checked";
      }
      return res;
    });
    return () => (
      <label class={checkboxClass.value}>
        <input
          type="checkbox"
          class="c-checkbox-input"
          checked={modelValue.value}
          onInput={(e: Event) => handleInput(e)}
          disabled={readonly.value || form?.readonly}
        />
        {slots?.default ? slots.default() : null}
        <div class="c-checkbox-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M13.9385 4.09246C13.8907 4.04748 13.8344 4.01239 13.773 3.98919C13.7116 3.966 13.6462 3.95516 13.5805 3.9573C13.5149 3.95943 13.4503 3.9745 13.3905 4.00165C13.3307 4.02879 13.2769 4.06747 13.232 4.11546L6.58854 11.2075L3.14404 8.31346C3.09403 8.26939 3.03571 8.23577 2.97252 8.21457C2.90932 8.19336 2.84253 8.18501 2.77606 8.19C2.70958 8.19499 2.64478 8.21322 2.58546 8.24362C2.52614 8.27401 2.47349 8.31597 2.43062 8.36701C2.38775 8.41805 2.35551 8.47715 2.33581 8.54083C2.31611 8.60451 2.30934 8.67148 2.3159 8.73782C2.32247 8.80415 2.34222 8.8685 2.37402 8.92709C2.40581 8.98567 2.449 9.03731 2.50104 9.07896L6.30804 12.2775C6.39803 12.3532 6.51192 12.3947 6.62954 12.3945C6.69798 12.3947 6.76573 12.3808 6.82854 12.3536C6.89134 12.3264 6.94786 12.2865 6.99454 12.2365L13.9615 4.79946C14.0065 4.75154 14.0415 4.69524 14.0647 4.63376C14.0879 4.57229 14.0987 4.50686 14.0965 4.4412C14.0944 4.37554 14.0794 4.31095 14.0522 4.25111C14.0251 4.19127 13.9865 4.13736 13.9385 4.09246Z"
              fill="#3F6FB8"
            />
          </svg>
        </div>
      </label>
    );
  },
});
